import React from 'react';
// import Link from 'next/link';
import Image from 'next/image';
import {useState, useEffect} from 'react';

import {getAuctionItemImg} from '@utils/functions';
import styles from '@styles/dropAuction/topAuction.module.scss';
import {useApp} from '@context/AppProvider';

const TopAuctionItemCard = props => {
	const {data} = props;
	const {convertCurrency} = useApp();

	const productData = data.productData[0];
	return (
		<div className={styles.card}>
			<div className={styles.card__content}>
				<div className={styles.card__content__imageContainer}>
					<ImageBlock
						data={{
							name: productData?.product_name,
							image: productData?.image_url || getAuctionItemImg(data),
						}}
					/>
				</div>

				<div className={styles.card__content__manufacturer}>
					<h2 style={{fontSize: '1rem', fontWeight: '600'}}>
						{productData?.manufacturer_name}
					</h2>
				</div>
				<div className={styles.card__content__description}>
					<p>{productData?.product_name}</p>
					<span>From {productData?.manufacturer_name}</span>
				</div>
			</div>
			<div className={styles.card__price}>
				<p>{convertCurrency(productData?.price)}</p>
			</div>
		</div>
	);
};

function ImageBlock({data}) {
	const [image, setImage] = useState('/img/loading.png');
	useEffect(() => {
		setImage(data.image);
	}, [data.image]);
	return (
		<div className={styles.imageWrapper}>
			<Image
				src={image}
				alt={data.name}
				layout='fill'
				objectFit='contain'
				placeholder='blur'
				blurDataURL='/img/loading.png'
				onError={e => {
					e.target.style['background-image'] = 'unset';
					setImage('/assets/svg/placeholder.svg');
				}}
			/>
		</div>
	);
}

export default TopAuctionItemCard;
